module.exports = __webpack_public_path__ + "static/media/repsol-logo.5de0bd32.png";